module.exports = __webpack_public_path__ + "img/fsa-store-logo.e75f2c8e.png";